import { useSortable } from '@dnd-kit/sortable'
import type { NotebookNote } from '../../../shared/types/notebook'
import type { DropPosition } from '../dndTree'
import PageRow from './PageRow'

interface SortablePageRowProps {
  note: NotebookNote
  depth: number
  isExpanded: boolean
  isActive: boolean
  hasChildren: boolean
  activeDragId: string | null
  dropTargetId: string | null
  dropPosition: DropPosition | null
  onToggleExpand: () => void
  onNavigate: (id: string) => void
  onCreateChild: (parentId: string) => void
}

export default function SortablePageRow({
  note,
  depth,
  isExpanded,
  isActive,
  hasChildren,
  activeDragId,
  dropTargetId,
  dropPosition,
  onToggleExpand,
  onNavigate,
  onCreateChild,
}: SortablePageRowProps) {
  const isTemp = note.id.startsWith('note-')

  const {
    setNodeRef,
    listeners,
    isDragging,
  } = useSortable({
    id: note.id,
    disabled: isTemp,
  })

  const isDropTarget = dropTargetId === note.id && activeDragId !== note.id

  return (
    <div ref={setNodeRef} {...(isTemp ? {} : listeners)}>
      <PageRow
        note={note}
        depth={depth}
        isExpanded={isExpanded}
        isActive={isActive}
        hasChildren={hasChildren}
        isDragging={isDragging}
        isDropTarget={isDropTarget}
        dropPosition={isDropTarget ? dropPosition : null}
        onToggleExpand={onToggleExpand}
        onNavigate={onNavigate}
        onCreateChild={onCreateChild}
      />
    </div>
  )
}
